module.exports = __webpack_public_path__ + "static/media/artwork-proofing.783e0976.svg";